var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amap-controls",staticStyle:{"min-width":"500px","min-height":"300px"}},[_c('div',{ref:"js-container",staticClass:"map",staticStyle:{"width":"700px","height":"300px"}},[_vm._v("\n    正在加载数据 ...\n  ")]),_vm._v(" "),_c('div')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-798d59dd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/store/components/amapControls.vue
// module id = null
// module chunks = 